import { FaServer, FaChartBar, FaHistory } from 'react-icons/fa';
import { ENUM_PERMISSIONS } from '../../../interaces/enums/enums.interface';
export const tabs = [
  { id: 'SERVICIOS', icon: <FaServer />,permission:ENUM_PERMISSIONS.MOD_INTEROP_SERVICES_READ },
  { id: 'METRICAS', icon: <FaChartBar />,permission:ENUM_PERMISSIONS.MOD_INTEROP_METRICS_READ },
  { id: 'HISTORIAL', icon: <FaHistory /> ,permission:ENUM_PERMISSIONS.MOD_INTEROP_HISTORY_READ},
];

export const TABS_OPTIONS = {
  SERVICES: 'SERVICIOS',
  METRICS: 'METRICAS',
  RECORD: 'HISTORIAL',
};


export const STATUS_CLASSES = {
  CONECTADO: {
    backgroundColor: 'var(--color-status-connected-bg)',
    color: 'var(--color-status-connected-text)',
  },
  MANTENIMIENTO: {
    backgroundColor: 'var(--color-status-maintenance-bg)',
    color: 'var(--color-status-maintenance-text)',
  },
  DESCONECTADO: {
    backgroundColor: 'var(--color-status-disconnected-bg)',
    color: 'var(--color-status-disconnected-text)',
  },
};
